<template>
  <button :class="[$style.hamburger, open ? $style.close : '' ]">
    <div :class="[$style.hamburgerContainer]">
      <span></span>
    </div>
  </button>
</template>

<script>
export default {
  props: ['open']
}
</script>


<style lang="scss" module>
.hamburger {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 44px;
  height: 44px;
  margin: auto;
  padding: 12px;

  background: none;
  border: 0;
  border-radius: 40px;

  visibility: visible;
  cursor: pointer;

  background: black;

  &:focus {
    outline: none;
  }

  .hamburgerContainer {
    position: relative;
    width: 20px;
    height: 20px;

    transform: scale(0.8);
  }

  :global(.no-touchevents) &:hover .hamburgerContainer {
    span {
      transform: scaleX(0.5) scaleY(1);
      background-color: lighten($color-ui, 60%);
    }

    &::after {
      transform: translate3d(-100%, 0, 0);
      background-color: lighten($color-ui, 60%);
    }

    &::before {
      transform: translate3d(100%, 0, 0);
      background-color: lighten($color-ui, 60%);
    }
  }

  &.close .hamburgerContainer {
    span {
      transform: rotate(-45deg) scale(1.38, 1);
    }

    &::after {
      transform: rotate(45deg);
    }

    &::before {
      transform: rotate(45deg);
    }
  }

  span {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 1px;
    background: lighten($color-ui, 60%);
    transition: all 0.35s ease-out;
  }

  & .hamburgerContainer::after,
  & .hamburgerContainer::before {
    content: "";
    position: absolute;
    height: 1px;
    width: 50%;
    background: lighten($color-ui, 40%);
    transition: all 0.3s ease-out;
  }

  & .hamburgerContainer::after {
    right: 0;
    bottom: 0;
    transform-origin: 100% 50%;
  }

  & .hamburgerContainer::before {
    left: 0;
    top: 0;
    transform-origin: 0 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hamburger.vue